module.exports = __webpack_public_path__ + "./assets/favicon-96x96.6ee686.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/favicon-96x96.png
// module id = 1074
// module chunks = 0